import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  itemLabel: string;
  onConfirm: () => void | Promise<void>;
  isPending?: boolean;
};

export function ConfirmDeleteDialog({ open, onOpenChange, itemLabel, onConfirm, isPending }: Props) {
  const [step, setStep] = useState<1 | 2>(1);

  useEffect(() => {
    if (!open) setStep(1);
  }, [open]);

  async function handleFinalConfirm() {
    await onConfirm();
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        {step === 1 ? (
          <>
            <DialogHeader>
              <DialogTitle>Eliminare {itemLabel}?</DialogTitle>
              <DialogDescription>
                Questa operazione richiede una doppia conferma.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="gap-2">
              <Button variant="outline" onClick={() => onOpenChange(false)}>
                Annulla
              </Button>
              <Button variant="destructive" onClick={() => setStep(2)}>
                Elimina
              </Button>
            </DialogFooter>
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>Conferma definitiva</DialogTitle>
              <DialogDescription>
                Stai per eliminare <span className="font-medium text-(--color-foreground)">{itemLabel}</span>.
                L'operazione è irreversibile.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="gap-2">
              <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
                Annulla
              </Button>
              <Button variant="destructive" onClick={handleFinalConfirm} disabled={isPending}>
                {isPending ? 'Eliminazione…' : 'Elimina definitivamente'}
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
